<template>
  <dl class="Params row">
    <dt class="col-3">Season</dt>
    <dd class="col-3">{{ replay.season }}</dd>

    <dt class="col-3">File Size</dt>
    <dd class="col-3">{{ filesize (replay.size) }}</dd>

    <!--
    <dt class="col-md-3">Map</dt>
    <dd class="col-md-3">{{ replay.data.game.map }}</dd>

    <dt class="col-md-3">Type</dt>
    <dd class="col-md-3">{{ replay.data.game.type }}</dd>
    -->

    <dt class="col-3">Ladder</dt>
    <dd class="col-3">{{ replay.ladder }}</dd>

    <dt class="col-3">Overridable</dt>
    <dd class="col-3">{{ lang (replay.overridable) }}</dd>

    <!-- <dt class="col-3">Host</dt>
    <dd class="col-3">{{ replay.data.game.host }}</dd> -->

    <dt class="col-3">Uploaded</dt>
    <dd class="col-3">{{ timeago (replay.playedOn) }}</dd>

    <dt class="col-3">Processed</dt>
    <dd class="col-3">
      {{ replay.processed ? 'Yes' : 'No' }}
    </dd>

    <dt class="col-3">Downloaded</dt>
    <dd class="col-3">
      {{ replay.downloads || 0 }} time{{ replay.downloads === 1 ? '' : 's' }}
    </dd>

    <dt class="col-3">Rated</dt>
    <dd class="col-3">
      {{
        replay.isVoid ? 'Voided' :
          (replay.flags & CST.REPLAY_RATED ? 'Yes' : 'No')
      }}
    </dd>

    <!--

    <dt class="col-md-3">Saver</dt>
    <dd class="col-md-3">
      {{ replay.getSaver ().name }}
    </dd>


    <dt class="col-md-3">Speed</dt>
    <dd class="col-md-3">{{ replay.data.game.speed }}</dd>

    <dt class="col-md-3">Players</dt>
    <dd class="col-md-3">{{ replay.data.game.players.length }}</dd>

    <dt class="col-md-3">Version</dt>
    <dd class="col-md-3">1.{{ replay.data.header.majorVersion }}.{{ replay.data.header.buildVersion }}</dd>

    <dt class="col-md-3">Locked Teams</dt>
    <dd class="col-md-3">Yes</dd>

    <dt class="col-md-3">Teams Together</dt>
    <dd class="col-md-3">Yes</dd>

    <dt class="col-md-3">Full Share</dt>
    <dd class="col-md-3">Yes</dd>

    <dt class="col-md-3">Random Races</dt>
    <dd class="col-md-3">No</dd>

    <dt class="col-md-3">Random Hero</dt>
    <dd class="col-md-3">No</dd>

    <dt class="col-md-3">Observers</dt>
    <dd class="col-md-3">Full Observers</dd>

    <dt class="col-md-3">Visiblity</dt>
    <dd class="col-md-3">Default</dd>
    -->
  </dl>
</template>

<script>
  import { time, timeago, isRated, filesize } from '@/legacy/lib//util';
  import { lang } from '@/legacy/lib//lang';
  import CST from '@/legacy/lib//Constants';

  export default {
    props: {
      replay: {
        type: Object
      }
    },

    data: () => {
      return {
        CST
      };
    },

    methods: {
      time,
      timeago,
      isRated,
      filesize,
      lang
    }
  }
</script>

<style lang="scss">
  .Params {
    border: fetch(border faint);
    padding: 25px 15px;
    margin: 40px 10px;

    background-color: rgba(var(--black), .6);

    dd {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>